/* eslint-disable import/prefer-default-export */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { createContext } from 'react';
import { render } from 'react-dom';
import { InertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import Echo from 'laravel-echo';
import theme from './theme';

export const ThemeContext = createContext(theme);

InertiaProgress.init({
  color: '#c7e2f4',
  delay: 250,
});

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '85c5fa7f67056bfe91b2',
  cluster: 'mt1',
  forceTLS: true,
});

window.csrfToken = function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
};

const app = document.getElementById('app');

render(
  <ThemeContext.Provider value={theme}>
    <InertiaApp
      initialPage={JSON.parse(app.dataset.page)}
      resolveComponent={(name) => import(`./Pages/${name}`).then((module) => module.default)}
    />
  </ThemeContext.Provider>,
  app,
);
